import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M975.988 63.065C960.052 24.155 921.845-.933 879.862.027H141.578a101.885 101.885 0 0 0-71.934 173.82l337.59 324.087v322.36c0 11.583 4.48 22.719 12.608 31.039l153.852 157.5a44.159 44.159 0 0 0 32 13.631 44.159 44.159 0 0 0 44.606-44.159l.064-482.547L956.02 173.91a101.885 101.885 0 0 0 19.904-110.78z" /></svg>

const Filter = React.forwardRef((props, ref) => {
  return (
    <IconBase name="filter" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Filter.displayName = 'IconFilter'

export default Filter
